/**
 * BETA — shelf-location CRUD.
 */
import { httpError } from "../router.js";
import { paginate, matchSearch, newId, nowIso } from "./_utils.js";

const CODE_RE = /^[A-Z][0-9]-[0-9]{2}$/;

export function register(route) {
  route("GET", "/emplacements", (ctx) => {
    const { params, store } = ctx;
    let rows = [...(store.data.emplacements || [])];
    if (params.produit_id) rows = rows.filter((e) => e.produit_id === params.produit_id);
    if (params.zone) rows = rows.filter((e) => e.zone === params.zone);
    if (params.q) rows = rows.filter((e) => matchSearch(e, params.q, ["code", "numero_lot"]));
    return paginate(rows, params);
  });

  route("GET", "/emplacements/produit/:produitId", (ctx) =>
    ctx.store.data.emplacements.filter((e) => e.produit_id === ctx.params.produitId),
  );

  route("GET", "/emplacements/:id", (ctx) => {
    const e = ctx.store.data.emplacements.find((x) => x.id === ctx.params.id);
    if (!e) httpError(404, "Emplacement introuvable", "NOT_FOUND");
    return e;
  });

  route("POST", "/emplacements", (ctx) => {
    const body = ctx.body || {};
    if (!CODE_RE.test(body.code || "")) {
      httpError(400, "Code emplacement invalide (format AA-00 requis)", "INVALID_CODE");
    }
    const created = {
      id: newId("emp"),
      created_at: nowIso(),
      zone: (body.code || "")[0] || "A",
      quantite: 0,
      notes: "",
      ...body,
    };
    ctx.store.data.emplacements.push(created);
    ctx.commit();
    return created;
  });

  route("PATCH", "/emplacements/:id", (ctx) => {
    const e = ctx.store.data.emplacements.find((x) => x.id === ctx.params.id);
    if (!e) httpError(404, "Emplacement introuvable", "NOT_FOUND");
    Object.assign(e, ctx.body || {});
    ctx.commit();
    return e;
  });

  route("DELETE", "/emplacements/:id", (ctx) => {
    ctx.store.data.emplacements = ctx.store.data.emplacements.filter((x) => x.id !== ctx.params.id);
    ctx.commit();
    return { success: true };
  });
}
